var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoonHollow = function SvgMoonHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.524 2.075c-.727-.23-1.35.566-.964 1.224.61 1.038.938 2.21.938 3.385A6.667 6.667 0 0 1 5.83 13.35a6.9 6.9 0 0 1-2.031-.313c-.727-.23-1.375.566-.99 1.224C4.292 16.79 7 18.351 9.998 18.351a8.333 8.333 0 0 0 8.333-8.334 8.305 8.305 0 0 0-5.807-7.942m1.328 2.5a6.66 6.66 0 0 1 2.813 5.442 6.667 6.667 0 0 1-6.667 6.667c-1.69 0-3.235-.65-4.427-1.719.089.003.172.052.26.052a8.333 8.333 0 0 0 8.334-8.333c0-.714-.127-1.421-.313-2.11"
  })));
};
export default SvgMoonHollow;